import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoginHook from "./../../hook/auth/login-hook";
import { ToastContainer } from "react-toastify";
import ValidTORMessages from "./ValidMessages/ValidMessages";
import validatePassword from "../../Feature/PassworValidRegex";
import { validateEmail } from "../../Feature/EmailValidRegex";

const LoginPage = () => {
  const [
    email,
    password,
    loading,
    onChangeEmail,
    onChangePassword,
    rememberMe,
    onChangeRememberMe,
    onSubmit,
    isPress,
    isComplate,
    showPassword,
    togglePasswordVisibility,
  ] = LoginHook();

  const handleKeyUp = (e) => {
    if (e.code === "Enter" && isComplate) {
      onSubmit();
    }
  };

  return (
    <Container
      className="mx-auto shadow my-4"
      style={{ minHeight: "690px", width: "375px" }}
    >
      <Row className="py-5 d-flex justify-content-center">
        <Col sm="12" className="d-flex flex-column">
          <label className="title-login">تسجيل الدخول</label>

          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-at"></i>
            </div>
            <input
              value={email}
              onChange={onChangeEmail}
              placeholder="الايميل..."
              type="email"
              className="user-input"
              onKeyUp={handleKeyUp}
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
          </div>

          {email.length > 1 ? (
            <ValidTORMessages validlistError={validateEmail(email)} />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-lock"></i>
            </div>
            <input
              value={password}
              onChange={onChangePassword}
              placeholder="كلمه السر..."
              type={showPassword ? "text" : "password"}
              onKeyUp={handleKeyUp}
              className="user-input"
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
            <button
              className="bg-white"
              type="button"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className="fa fa-eye-slash"></i> // Hide password icon
              ) : (
                <i className="fa fa-eye"></i> // Show password icon
              )}
            </button>
          </div>

          <div className="d-flex justify-content-start align-items-center my-3">
            <input
              value={rememberMe}
              onChange={onChangeRememberMe}
              type="checkbox"
              className="form-check-input"
              style={{ marginLeft: "5px" }}
            />
            <h3 className="fs-6 mr-2">تذكرنى</h3>
          </div>
          {password.length > 1 ? (
            <ValidTORMessages validlistError={validatePassword(password)} />
          ) : null}
          {isComplate ? (
            <button onClick={onSubmit} className="btn-login">
              تسجيل الدخول
            </button>
          ) : (
            <button
              disabled
              className="bg-grey-500 btn"
              style={{
                cursor: "not-allowed",
              }}
            >
              تسجيل الدخول
            </button>
          )}
          <label className="my-3">
            ليس لديك حساب ؟{" "}
            <Link to="/register" style={{ textDecoration: "none" }}>
              <span style={{ cursor: "pointer" }} className="text-danger">
                اضغط هنا
              </span>
            </Link>
          </label>

          <label className="">
            <Link
              to="/user/forget-password"
              style={{ textDecoration: "none", color: "red" }}
            >
              هل نسيت كلمه السر
            </Link>
          </label>

          {isPress === true ? (
            loading === true ? (
              <Spinner animation="border" role="status"></Spinner>
            ) : null
          ) : null}
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default LoginPage;
